/* eslint-disable */
import Rate from './Rate';

export default Rate;
